/**
 * Base file to maintain all ajax-forms operations.
 * Contain default validation behaviour.
 * If need custom one, please use:
 * - jquery.shopgate.ajax-forms-checkout - for checkout related validations
 * - jquery.shopgate.ajax-forms-notification - for generic_notification system forms (apps only)
 * - ... or create new one if needed
 *
 */
;(function($) {
	$.fn.shopgateAjaxFormSubmit = function(options) {
		var defaults = {};

		options = options || {};
		options = $.extend({}, defaults, options);

		return this.each(function() {
			var currentForm = $(this),
				action = currentForm.attr('action'),
				submitButton = currentForm.find('input[type=submit]'),
				submitDisabled = false,
				isAjaxReloadForm = currentForm.hasClass('ajax-reload'),
				useWaitingIndicator = currentForm.data('useWaitingIndicator'),
				postRegex = /_method=POST&/i;

			$(this).data('shopgateAjaxFormSubmit', this);

			toggleSubmitDisabled(false);

			if (submitButton.length == 0) {
				submitButton = currentForm.find('button[type=submit]');
			}

			currentForm.unbind('submit').submit(function(e){
				// abort the real submit
				e.preventDefault();
                // updating the action
                action = $(this).attr('action');
				/* blur input fields after submitting the form to close the keypad */
				currentForm.find('input').blur();
				if (currentForm.data('submitDisabled')) {
					return false;
				}

				if (currentForm.data('submitOverridden')) {
					return;
				}

				if (action) {
                    if (isAjaxReloadForm) {
						var serializedData = currentForm.serialize();

						if (serializedData && !postRegex.test(serializedData)) {
							serializedData = '_method=POST&' + serializedData;
						}

						$.shopgate.ajaxContentUpdate({
							url: action,
							data: serializedData,
							beforeSend: _beforeSend,
							complete: _complete,
							error: _error,
							success: _success
						});
					}else{
						$.shopgate.ajax({
							url: action,
							data: currentForm.serialize(),
							beforeSend: _beforeSend,
							complete: _complete,
							error: _error,
							success: _success
						});
					}
				}
			});

			function toggleSubmitDisabled(disabled) {
				currentForm.data('submitDisabled', disabled ? true : false);
			}

			function _complete(jqXHR, textStatus) {
				toggleSubmitDisabled(false);
				submitButton.prop('disabled', false);
				submitButton.removeClass('disabled loading');
				if (isAjaxReloadForm || useWaitingIndicator) {
					$(document).trigger('shopgateFramework.waitingIndicator.hide');
				}
			}

			function _beforeSend(jqXHR, settings) {
				toggleSubmitDisabled(true);
				submitButton.prop('disabled', true);
				submitButton.addClass('disabled loading');

				if (isAjaxReloadForm || useWaitingIndicator) {
					$(document).trigger('shopgateFramework.waitingIndicator.show');
				}
			}

			function _error(jqXHR, textStatus, errorThrown) {}

			function _success(data, textStatus, jqXHR) {
				// check if the validation errors attribute is present in the response object
				if (typeof data.validationErrors == 'object') {
					_processValidationErrors(currentForm, data.validationErrors);
				} else {
					currentForm.trigger('sgFramework.forms.validation.reset');
				}

				delete(data.validationErrors);
				delete(data.shopBackLink);

				currentForm.trigger('shopgateFramework.forms.dataUpdate', [data]);
                $(document).trigger('shopgateFramework.forms.dataUpdate', [data]);
			}
		});

		/**
		 * Processes the validation errors within an ajax-form-submit response
		 * @param {object} errorsFromAjaxResponse
		 */
		function _processValidationErrors(currentForm, errorsFromAjaxResponse) {
			// reset the current errors - we don't know if we get some new in this response
			currentForm.trigger('sgFramework.forms.validation.reset');

			if (typeof errorsFromAjaxResponse == 'undefined' || !errorsFromAjaxResponse) {return false;}

			var validationErrorList = [];

			// iterate through the models
			$.each(errorsFromAjaxResponse, function(model, errors){
				var isComplex = false;

				// check if we got errors for a complex form ( > 1 record in one db-model)
				$.each(errors, function(key, value){
					if ($.isNumeric(key)) {
						isComplex = true;
					}

					return false;
				});

				var errorsPerModel = [];

				if ($.isArray(errors) || isComplex) {
					var errorsPerRow = [];

					$.each(errors, function(recordIndex, errorObject){
						var singleResult = _processValidationErrorObject(model, errorObject, recordIndex);
						errorsPerRow = $.merge(errorsPerRow, singleResult);
					});

					errorsPerModel = $.merge(errorsPerModel, errorsPerRow);
				} else {
					errorsPerModel = _processValidationErrorObject(model, errors);
				}

				validationErrorList = $.merge(validationErrorList, errorsPerModel);
			});

			// seems that we've processes all the errors. so we propagate them to the form so that another script can
			// create the needed markup to show them to the user
			currentForm.trigger('sgFramework.forms.validation.set', [validationErrorList]);

			/**
			 * Creates a list of name-tag values and validation error texts
			 */
			function _processValidationErrorObject(model, errorObject, recordIndex) {
				var errorList = [];

				$.each(errorObject, function(field, errorText){
					if (typeof recordIndex == 'undefined') {
						var elementName = "data["+model+"][" + field + "]";
					} else {
						var elementName = "data["+model+"]["+recordIndex+"][" + field + "]";
					}

					errorList.push({
						element: elementName,
						texts: errorText
					});
				});

				return errorList;
			}
		}
	};

	$.fn.shopgateAjaxFormValidationDefault = function(options) {
		var defaults = {};

		options = options || {};
		options = $.extend({}, defaults, options);

		return this.each(function() {
			var that = $(this);

			that.unbind('sgFramework.forms.validation.reset').bind('sgFramework.forms.validation.reset', function(e){
                that.find('.form-group').removeClass('has-error');
                that.find('.help-block').remove();
			}).unbind('sgFramework.forms.validation.set').bind('sgFramework.forms.validation.set', function(e, errors, preventScrolling){

				if (errors) {
					$.each(errors, function(index, error){
						if (error.element) {
							var elementName = error.element;

							// remove last char ']' for state ids
							if(elementName.indexOf('state_id') !== -1) {
								elementName = elementName.slice(0, -1);
							}

							var input = that.find("[name^='" + elementName + "']"),
								formGroup = input.closest('.form-group');

							formGroup.addClass('has-error');

							if (error.texts[0]) {

								var messages = error.texts.join('<br>');

								var help = $('<span class="help-block" />')
									.html(messages)
									.appendTo(formGroup);
							}
						}
					});

					var firstError = that.find('.has-error:visible').first();

					if (!preventScrolling && firstError.length > 0) {
						var scrollHeight = firstError.offset().top - (parseInt(firstError.css('marginTop')) / 2),
							scrollOffset = firstError.data('scrollOffset');

						if (scrollOffset) {
							scrollHeight = scrollHeight - scrollOffset;
						}

						if(parseInt($('body').css('paddingTop')) > 0){
							scrollHeight = scrollHeight - parseInt($('body').css('paddingTop'));
						}
						$('html,body').animate({scrollTop: scrollHeight}, 'slow');
					}
				}
			});
		});

	};

	$.fn.watchFormChanges = function () {
		return this.each(function () {
			$.data(this, 'formHash', $(this).serialize());
		});
	};

	$.fn.formHasChanged = function () {
		var hasChanged = false;

		this.each(function () {
			var formHash = $.data(this, 'formHash');

			if (formHash != null && formHash !== $(this).serialize()) {
				hasChanged = true;
				return false;
			}
		});

		return hasChanged;
	};

})(jQuery);


// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-ajax-forms.js